$(document).ready(function () {
    'use strict';

    let prevScrollPos = window.pageYOffset;
    var headerDiv = document.querySelector('.vebego-header');

    const headerSelectors = document.querySelectorAll(
        '.org-header .selector'
    );

    const logo = document.getElementById('header-logo');
    const logoAlternate = document.getElementById('header-logo-alternate');

    if (headerDiv) {
        function headerScroll() {
            let currentScrollPos = window.pageYOffset;

            const content = document.createElement('body');

            var scrolled = document.scrollingElement.scrollTop;
            var position = content.offsetTop;

            if (scrolled > position) {
                if (!headerDiv.classList.contains('.org-header--active')) {
                    if (prevScrollPos <= currentScrollPos) {
                        headerDiv.classList.add('scrolling-down');
                        headerDiv.classList.remove('scrolling-up');

                        setTimeout(function () {
                            if (headerSelectors) {
                                headerSelectors.forEach((selector) => {
                                    selector.classList.remove(
                                        'selector-active'
                                    );
                                });
                            }

                            if (logoAlternate) {
                                logo.classList.remove('hidden');
                                logoAlternate.classList.add('hidden');
                            }
                        }, 200);
                    } else {
                        headerDiv.classList.remove('scrolling-down');
                        headerDiv.classList.add('scrolling-up');
                    }
                }
            } else if (scrolled < position + 5) {
                setTimeout(function () {
                    headerDiv.classList.remove('scrolling-down');
                    headerDiv.classList.remove('scrolling-up');

                    if (logoAlternate) {
                        logo.classList.add('hidden');
                        logoAlternate.classList.remove('hidden');
                    }
                }, 200);
            }

            prevScrollPos = currentScrollPos;
        }

        $(window).on('scroll', function () {
            headerScroll();
        });
    }
});
